import { selectSigningOut } from '../../store/auth/selectors';
import { LogOutSquareIcon } from '../../assets/icons/common';
import { useDispatch, useSelector } from '../../store/store';
import { setSignOutModal } from '../../store/auth/slice';
import { signOutThunk } from '../../store/auth/thunks';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function SignOut() {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectSigningOut);

    const confirmSignOut = () => {
        dispatch(signOutThunk())
    };

    return (
        <Modal
            size='sm'
            title='Sign out'
            icon={<LogOutSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setSignOutModal(false))}
        >
            <span className={styles.text}>Are you sure you want to sign out ?</span>
            <div className={styles.actions}>
                <Button
                    text='Cancel'
                    type='Outline-Dark'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setSignOutModal(false))}
                />
                <Button
                    type='Error'
                    text='Sign out'
                    loading={isLoading}
                    onClick={confirmSignOut}
                    className={styles.actions_btn}
                />
            </div>
        </Modal>
    )
}
